@if (table(); as table) {
<lib-card>
	<lib-table [table]="table"></lib-table>
</lib-card>
} @if (defaultTable(); as defaultTable) {
<lib-card [title]="'Default progress types'" class="push-top-md">
	<lib-table [table]="defaultTable"></lib-table>
</lib-card>
}
